{
  "digital_twin_network": {
    "title": "Could not connect to the Digital Twin",
    "subtitle": "Let's run some checks to see what went wrong...",
    "title_success": "Connection test successful",
    "subtitle_success": "To connect to the Digital Twin, return to the map and click the Digital Twin button",
    "support_1": " Please review the ",
    "documentation": "Documentation",
    "support_2": " for firewall and connection settings. If this issue persists, please contact support at",
    "iventis_card": {
      "title": "Iventis",
      "subtitle": "Main application services"
    },
    "websocket_card": {
      "title": "Websocket",
      "subtitle": "Establish the Digital Twin connection"
    },
    "webRTC_card": {
      "title": "WebRTC",
      "subtitle": "Video and real-time communication to the Digital Twin"
    },
    "return_to_map": "Return to Map",
    "recommended_actions": {
      "title": "Suggested action",
      "iventis": "Please check your internet connection and try again. If the issue persists, please contact support at",
      "websocket": "Please check your network and firewall settings to ensure that Websocket connections are allowed and that there are no firewall rules blocking the connection to iventis.com. If the issue persists, please contact support at",
      "webRTC": "Please check your network and firewall settings to ensure that WebRTC connections are allowed, and that ports 19302, 19303, and 10000-65535 are open and allow STUN and TURN requests to iventis.com. If the issue persists, please contact support at"
    },
    "testing": "Testing your connection, please wait..."
  },
  "model_preview": {
    "toggle_bounding_box": "Toggle bounding box",
    "bounding_box_check": "Check the model fits within the bounding box",
    "bounding_box_check_dimensions": "Check the model fits within the bounding box and the dimensions are correct",
    "dimensions_warning": "Editing dimensions does not change the model size. These values are used as reference dimensions when applying custom sizing in layer styles",
    "length_axis_colour": "Red axis",
    "width_axis_colour": "Green axis",
    "height_axis_colour": "Blue axis",
    "advanced_options": "Advanced"
  },
  "data_table_filter": {
    "operator": "Operator"
  },
  "map_settings": {
    "interface_style": "Map interface style",
    "compressed": "Compressed",
    "spacious": "Spacious"
  }
}